import { Routes, Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import ReservationsReservationsScreen from "../../../container/Reservations/ReservationsReservationsScreen";
import CreateReservationsReservations from "../../../container/Reservations/ReservationsReservationsScreen/CreateReservationsReservations";
import ViewReservationsReservations from "../../../container/Reservations/ReservationsReservationsScreen/ViewReservationsReservations";

const ReservationsReservationsRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RESERVATIONS_RESERVATIONS.HOME}
          element={
            <ReservationsReservationsScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RESERVATIONS_RESERVATIONS.CREATE}
          element={<CreateReservationsReservations />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RESERVATIONS_RESERVATIONS.EDIT}
          element={<CreateReservationsReservations isEdit={true} />}
        />
      )}
      {!!view && (
        <Route
          path={APP_URLS.RESERVATIONS_RESERVATIONS.VIEW}
          element={<ViewReservationsReservations isEdit={true} />}
        />
      )}
    </>
  );
};

export default ReservationsReservationsRoutes;
